// extracted by mini-css-extract-plugin
module.exports = {"item":"ValueOrientedContent_item__DxzHk","trigger":"ValueOrientedContent_trigger__wKbfY","content":"ValueOrientedContent_content___NvPF"};